/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';

export interface EconomicIndicatorsCapexsList$Params {
  /**
   * * `3` - Не облагается
   * * `1` - Экспортная ставка
   * * `2` - Льготная ставка
   * * `0` - Основная ставка
   * * `4` - Ставка продаж физ. лицам
   * * `5` - Ставка продаж юр. лицам
   */
  VAT_rate?: 0 | 1 | 2 | 3 | 4 | 5;
  VAT_refund?: boolean;
  amortization_premium?: number;
  amount_capital_expenditure?: number;
  deprication_period?: number;
  end_date?: string;
  group?: number;
  intangible_asset?: boolean;
  is_blocked?: boolean;
  leasing_switch?: boolean;
  liquidation_cost?: number;
  liquidation_cost_VAT_rate?: number;
  liquidation_cost_switch?: boolean;
  liquidation_profit?: number;
  liquidation_profit_VAT_rate?: number;
  liquidation_profit_switch?: boolean;
  name?: string;

  /**
   * A search term.
   */
  search?: string;
  start_date?: string;
  taxdeprication_period?: number;
  taxdeprication_switch?: boolean;
  variant?: number;
}

export function economicIndicatorsCapexsList(
  http: HttpClient,
  rootUrl: string,
  params?: EconomicIndicatorsCapexsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCapexDto>>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexsList.PATH, 'get');
  if (params) {
    rb.query('VAT_rate', params.VAT_rate, {});
    rb.query('VAT_refund', params.VAT_refund, {});
    rb.query('amortization_premium', params.amortization_premium, {});
    rb.query('amount_capital_expenditure', params.amount_capital_expenditure, {});
    rb.query('deprication_period', params.deprication_period, {});
    rb.query('end_date', params.end_date, {});
    rb.query('group', params.group, {});
    rb.query('intangible_asset', params.intangible_asset, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('leasing_switch', params.leasing_switch, {});
    rb.query('liquidation_cost', params.liquidation_cost, {});
    rb.query('liquidation_cost_VAT_rate', params.liquidation_cost_VAT_rate, {});
    rb.query('liquidation_cost_switch', params.liquidation_cost_switch, {});
    rb.query('liquidation_profit', params.liquidation_profit, {});
    rb.query('liquidation_profit_VAT_rate', params.liquidation_profit_VAT_rate, {});
    rb.query('liquidation_profit_switch', params.liquidation_profit_switch, {});
    rb.query('name', params.name, {});
    rb.query('search', params.search, {});
    rb.query('start_date', params.start_date, {});
    rb.query('taxdeprication_period', params.taxdeprication_period, {});
    rb.query('taxdeprication_switch', params.taxdeprication_switch, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCapexDto>>;
    }),
  );
}

economicIndicatorsCapexsList.PATH = '/api/economic_indicators/capexs/';
